import React from "react";

import ContentWrapper from "./util/ContentWrapper";

import Notice from "./list/subBox/notice/Notice";
import ShortCut from "./list/subBox/shortCut/ShortCut";
import CurrentStar from "./list/subBox/currentStar/CurrentStar";
import PlanStudy from "./list/subBox/planStudy/PlanStudy";
import Qna from "./list/subBox/qna/Qna";
import RecentStudy from "./list/subBox/recentStudy/RecentStudy";
import ButtonType from "./list/subBox/ButtonType/ButtonType";
import WidgetButtons from "./list/subBox/widgetButtons/WidgetButtons";

function ListContent({ drawerList, toggleList, platformType, callEmptyAlert, lnbRef }) {
    return (
        <ContentWrapper lnbRef={lnbRef}>
            {drawerList
                .sort((a, b) => a.DSP_NO > b.DSP_NO)
                .map((info, idx) => {
                    if (info.DRWR_CD === "NOTI") {
                        // 알림함
                        return (
                            <Notice
                                key={idx}
                                info={info}
                                menuUrl={info.MENU_URL}
                                menuLink={info.MENU_URL}
                                menuTypeCode={info.MENU_TY_CD}
                                noticeList={info.SUB_DRWR}
                                titleText={info.DRWR_NAME}
                                noItemText={info.BSC_MSG}
                                callEmptyAlert={callEmptyAlert}
                                drawCd={info.DRWR_CD}
                            />
                        );
                    } else if (info.DRWR_CD === "QICK") {
                        // 바로가기
                        return (
                            <ShortCut
                                info={info}
                                key={idx}
                                shortCutList={info.SUB_DRWR}
                                titleText={info.DRWR_NAME}
                                drawCd={info.DRWR_CD}
                            />
                        );
                    } else if (info.DRWR_CD === "RWRD") {
                        // 내 별 현황
                        return (
                            <CurrentStar
                                info={info}
                                key={idx}
                                menuTypeCode={info.MENU_TY_CD}
                                currentStarList={info.SUB_DRWR}
                                menuLink={info.MENU_URL}
                                titleText={info.DRWR_NAME}
                                drawCd={info.DRWR_CD}
                            />
                        );
                    } else if (info.DRWR_CD === "PSTD") {
                        // 계획학습
                        return (
                            <PlanStudy
                                key={idx}
                                info={info}
                                menuTypeCode={info.MENU_TY_CD}
                                menuLink={info.MENU_URL}
                                planStudyList={info.SUB_DRWR}
                                titleText={info.DRWR_NAME}
                                drawCd={info.DRWR_CD}
                            />
                        );
                    } else if (info.DRWR_CD === "QNNA") {
                        // 나의 강좌 Q&A
                        return (
                            <Qna
                                key={idx}
                                info={info}
                                menuTypeCode={info.MENU_TY_CD}
                                menuLink={info.MENU_URL}
                                qnaList={info.SUB_DRWR}
                                titleText={info.DRWR_NAME}
                                noItemText={info.BSC_MSG}
                                drawCd={info.DRWR_CD}
                            />
                        );
                    } else if (info.DRWR_CD === "NSTD") {
                        // 최근 학습하지 않은 강의
                        return (
                            <RecentStudy
                                key={idx}
                                info={info}
                                menuTypeCode={info.MENU_TY_CD}
                                menuLink={info.MENU_URL}
                                recentStudyList={info.SUB_DRWR}
                                titleText={info.DRWR_NAME}
                                noItemText={info.BSC_MSG}
                                drawCd={info.DRWR_CD}
                            />
                        );
                    } else if (info.DRWR_CD === "PLAN") {
                        // 오늘의 계획 학습 추가
                        return (
                            <ButtonType
                                key={idx}
                                info={info}
                                drwrCode={info.DRWR_CD}
                                menuTypeCode={info.MENU_TY_CD}
                                buttonInfo={info.SUB_DRWR}
                                addBoxClass="add1"
                            />
                        );
                    } else if (info.DRWR_CD === "WANT") {
                        // 오답노트 바로 확인
                        return (
                            <ButtonType
                                key={idx}
                                info={info}
                                drwrCode={info.DRWR_CD}
                                menuTypeCode={info.MENU_TY_CD}
                                buttonInfo={info.SUB_DRWR}
                                addBoxClass="add2"
                                drawCd={info.DRWR_CD}
                            />
                        );
                    }
                })}
            {/* 
                TODO Ipad는 서비스 나가기, 편집 기능을 사용하지 않는다.
                platformType은 학습 시작 플렛폼 타입 (StudyRoom, DEFAULT 등등)
                안드로이드 와 같이 사용시 디바이스 값으로 분기처리 필요.

                <WidgetButtons toggleList={toggleList} platformType={platformType} /> 
            */}
        </ContentWrapper>
    );
}

export default ListContent;
